import { render, staticRenderFns } from "./betRecord.vue?vue&type=template&id=79b452e8&scoped=true"
import script from "./betRecord.vue?vue&type=script&lang=js"
export * from "./betRecord.vue?vue&type=script&lang=js"
import style0 from "./betRecord.vue?vue&type=style&index=0&id=79b452e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b452e8",
  null
  
)

export default component.exports